module.exports = __webpack_public_path__ + "img/qlc.c1056adb.svg";